import React, { useState, useEffect } from "react";
import "../../components/AddSupplier/AddSupplier.css";
import axios from "axios";

const AddSupplier = ({tokenStorage,openAddProfile,setOpenAddProfile}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    SupplierID: "",
    supplierName: "",
    emailID: "",
    phoneNumber: "",
    Address: "",

    createdBy: "Vishal",
  });

  const [isEmailValid, setIsEmailValid] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "emailID") {
      // Use a simple check for email validity
      const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      setIsEmailValid(isValid);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isEmailValid) {
      // Optionally, you can display an error message or handle it in any way you prefer.
      console.error("Invalid email address");
      return;
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddSupplierDetail`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      
      // Optionally, reset the form
      setFormData({
        SupplierID: "",
        supplierName: "",
        emailID: "",
        phoneNumber: "",
        Address: "",

        createdBy: "Vishal",
      });
      tokenStorage();
      setOpenAddProfile (!openAddProfile);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="supplierDetail">
        <div className="supplier-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Supplier Name</td>
              <td>Email Id</td>
              <td>Phone No.</td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  name="supplierName"
                  value={formData.supplierName}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  type="email"
                  name="emailID"
                  // pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  value={formData.emailID}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
                {!isEmailValid && (
                  <span style={{ color: "red" }}>Invalid email address</span>
                )}
              </td>
              <td>
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Address</td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  name="Address"
                  value={formData.Address}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addSupplier-button">
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddSupplier;
